import { Skeleton } from '@/components/ui/skeleton';

const IncidentDetailsLoader = () => {
  return (
    <div className="flex flex-col items-start gap-5 w-full pt-5">
      <Skeleton className="w-10 h-10 rounded-lg" />
      <div className="flex flex-col gap-5 w-full">
        <Skeleton className="h-5 w-full rounded-sm" />
        <Skeleton className="h-5 w-[134px] rounded-sm" />
        <Skeleton className="h-3.5 w-[199px] rounded-sm" />
        <Skeleton className="h-3 w-full rounded-sm" />
        <Skeleton className="h-3 w-full rounded-sm" />
      </div>
    </div>
  );
};

export default IncidentDetailsLoader;
